import React from "react";
import { ExternalProps } from "src/types.js";
import { InfiniteScroll } from "./InfiniteScroll.js";
import { Pagination } from "./Pagination.js";
import { ExternalPropsProvider } from "./providers/ExternalPropsProvider.js";
import { RecommendationsProvider } from "./providers/RecommendationsProvider.js";

export const App = (props: ExternalProps) => {
	return (
		<ExternalPropsProvider {...props}>
			<RecommendationsProvider proxyUrl={props.proxyUrl} parameters={props.parameters}>
				{props.parameters.variant === "infinite-scroll" ? <InfiniteScroll /> : <Pagination />}
			</RecommendationsProvider>
		</ExternalPropsProvider>
	);
};
